<template>
  <div id="wizardCard" class="card card-wizard">
    <div class="vue-form-wizard md">
      <div class="content">
        <div class="container">
          <div class="row">
            <legend>Permisos y Roles</legend>
          </div>
          <div v-if="add_item">
            <div class="row">
              <div class="form-group col-md-6">
                <legend>Nombre del rol</legend>
                <input class="form-control" type="text" name="Rol" v-validate="'required|min:1'" v-model="item_permisos.Rol" placeholder=""><small class="text-danger" v-show="Rol.invalid">
                  {{ getError('Rol') }}
                </small>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-12">
                <legend>Permisos del rol</legend>
                <el-transfer class="d-flex justify-content-center" name="permisos" v-validate="'required|min:1'" v-model="item_permisos.Permisos" :titles="['Lista de permisos', 'Permisos activos']" :data="list_cat_permisos" :props="{key: 'id',label: 'permiso'}">
                </el-transfer>
                <small class="text-danger">{{ getError('permisos') }}</small>
              </div>
            </div>
            <div class="row justify-content-end m-3">
              <button class="btn btn-primary" @click.prevent="addItem()">
                <span v-if="edit_item == null">
                  <i class="fa fa-plus"></i> Agregar </span>
                <span v-else>
                  <i class="fa fa-save"></i> Guardar </span>
              </button>
              <button class="btn btn-danger ml-3" @click.prevent="cancelEdit()">
                <span>
                  <i class="fa fa-times"></i> Cancelar </span>
              </button>
            </div>
            <div class="row">
              <hr class="col-md-12 bg-info">
            </div>
          </div>
          <div v-if="!add_item">
            <div class="row">
              <div class="col-md-6">
                <button class="btn btn-primary" @click.prevent="showItem()">
                  <span>
                    <i class="fa fa-plus"></i> Agregar </span>
                </button>
              </div>
              <div class="col-sm-6 col-md-6 col-lg-6 pull-right">
                <b-form-group>
                  <b-input-group>
                    <b-form-input type="search" v-model="filter" placeholder="Buscar"></b-form-input>
                  </b-input-group>
                </b-form-group>
              </div>
            </div>
            <div class="row mt-3 mb-4">
              <div class="col-sm-12 col-md-12 col-lg-12">
                <v-data-table :headers="headers" :items="list_permisos" :items-per-page="5" class="" :search="filter" :fixed-header="true">
                  <template v-slot:item.acciones="{ item }">
                    <div class="d-flex justify-content-center">
                      <b-button @click.prevent="editItem(item)" class="btn-s edit mr-2" variant="success" :disabled="edit_item != null">
                        <i class="fas fa-pencil-alt"></i></b-button>
                      <br>
                      <b-button @click.prevent="removeItem(item)" class="btn-s delete" variant="danger" :disabled="edit_item != null">
                        <i class="fas fa-times"></i></b-button>
                    </div>
                  </template>
                </v-data-table>
                <!-- <b-table striped id="tbl_metales" responsive hover :items="list_permisos" :fields="fields_list" show-empty :filter="filter">
                  <template slot="acciones" slot-scope="row" class="actions">
                    <b-button size="sm" @click.prevent="editItem(row)" variant="success" class="edit mr-2" :disabled="edit_item != null"> Editar <i class="fas fa-pencil-alt ml-2"></i>
                    </b-button>
                    <br>
                    <b-button size="sm" @click.prevent="removeItem(row)" variant="danger" class="delete mr-2" :disabled="edit_item != null"> Eliminar <i class="fas fa-trash-alt ml-2"></i>
                    </b-button>
                  </template>
                  <template slot="empty">
                    <h5>No existen registros</h5>
                  </template>
                </b-table> -->
              </div>
              <!-- <div class="col-mb-8 col-8">
                <b-col md="6" class="my-1">
                  <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" first-text="<<" prev-text="<" next-text=">" last-text=">>" aria-controls="tbl_movimientos"></b-pagination>
                </b-col>
              </div>
              <div class="col-mb-12 col-12">
                <p class="category">Mostrando <b>{{from + 1}}</b> a <b>{{to}}</b> de <b>{{total}}</b> registros</p>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from "vue";
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  import {
    Select,
    Transfer,
    Option
  } from "element-ui";
  import {
    mapFields
  } from "vee-validate";
  Vue.use(Select);
  Vue.use(Option);
  Vue.use(Transfer);
  export default {
    components: {
      PPagination
    },
    props: ["data"],
    data() {
      return {
        perPage: 10,
        rows: null,
        currentPage: 1,
        filter: null,
        ip_id: 1,
        add_item: false,
        edit_item: null,
        permiso: [],
        item_permisos: {},
        list_permisos: [],
        list_cat_permisos: [],
        item_permisosValidations: {
          Rol: {
            required: true
          }
        },
        /* fields_list: [{
          key: "acciones",
          label: "Acciones",
          tdClass: 'ancho',
          thClass: 'ancho',
          width: 150
        }, {
          key: "Rol",
          label: "Rol"
        }], */
        headers: [{
          text: 'Acciones',
          align: 'center',
          sortable: false,
          value: 'acciones',
          class: '',
          width: 150
        }, {
          text: 'Rol',
          value: 'Rol',
          align: 'center',
        }, ],
      };
    },
    computed: {
      ...mapFields(["Rol"]),
      pagedData() {
        return this.list_permisos.slice(this.from, this.to)
      },
      queriedData() {
        if (!this.searchQuery) {
          this.pagination.total = this.list_permisos.length
          return this.pagedData
        }
        let result = this.list_permisos.filter((row) => {
          let isIncluded = false
          for (let key of this.propsToSearch) {
            let rowValue = row[key].toString()
            if (rowValue.includes && rowValue.includes(this.searchQuery)) {
              isIncluded = true
            }
          }
          return isIncluded
        })
        this.pagination.total = result.length
        return result.slice(this.from, this.to)
      },
      to() {
        let highBound = this.from + this.perPage;
        if (this.total < highBound) {
          highBound = this.total;
        }
        return highBound;
      },
      from() {
        return this.perPage * (this.currentPage - 1);
      },
      total() {
        //console.log(this.list_permisos.length);
        this.rows = this.list_permisos.length;
        return this.list_permisos.length;
      }
    },
    watch: {
      '$route': 'checkPermissions'
    },
    methods: {
      checkPermissions() {
        let permiso = [9];
        if (!this.getKey('permisos').some(r => permiso.includes(r))) {
          localStorage.clear();
          this.$router.push('/login');
          this.$router.go();
        }
      },
      initItem() {
        this.item_permisos = {
          acciones: "",
          Rol: "",
          Permisos: []
        };
      },
      showItem() {
        this.add_item = !this.add_item;
        if (this.add_item) {
          this.$validator.resume();
        } else {
          this.$validator.pause();
        }
      },
      cancelEdit() {
        /* if (this.edit_item) {
          this.edit_item.item._rowVariant = "";
        } */
        this.initItem();
        this.showItem();
        this.edit_item = null;
      },
      addItem() {
        this.$validator.validateAll().then(response => {
          if (response) {
            if (this.item_permisos) {
              //this.item_permisos.ip_id = this.ip_id;
              //console.log(this.item_permisos);
              this.loadButton(this.$refs.btnSave);
              this.$http.post("permisos", this.item_permisos).then(response => {
                this.StepOk("Guardado");
                if (this.edit_item === undefined || this.edit_item === null) {
                  this.list_permisos.push({
                    ...response.data.permiso
                  });
                } else {
                  let index = this.list_permisos.map(u => {
                    return u.id;
                  }).indexOf(response.data.permiso.id);
                  this.list_permisos.splice(index, 1, response.data.permiso);
                  //this.list_permisos.splice(this.edit_item.index, 1, this.item_permisos);
                  //this.edit_item.item._rowVariant = "";
                }
                this.initItem();
                this.showItem();
                this.edit_item = null;
              }, error => {
                this.StepError(error);
                //this.change =  true;
              });
            }
          } else {
            this.StepError("Hay campos sin completar", 2000);
          }
        });
        //console.log(this.item_empresas);
      },
      editItem(indice) {
        this.showItem();
        this.edit_item = indice;
        this.item_permisos = {
          //...this.list_permisos[this.edit_item.index]
          ...this.edit_item
        };
        //this.edit_item.item._rowVariant = "danger";
        $(".main-panel").animate({
          scrollTop: 100
        }, 500, "swing");
      },
      removeItem(item) {
        if (item.id !== null) {
          //let item = this.list_permisos[indice];
          this.Ask("Desea borrar este registro", () => {
            this.$http.delete("permisos/" + item.id).then(response => {
              this.StepOk('Permiso Eliminado')
              let index = this.list_permisos.map(u => {
                return u.id;
              }).indexOf(item.id);
              this.list_permisos.splice(index, 1);
            }, error => {
              this.Err(error);
            });
          });
        }
      },
      getError(fieldName) {
        return this.errors.first(fieldName);
      }
    },
    created() {
      this.checkPermissions();
      this.initItem();
      this.$http.get("permisos").then(response => {
        this.list_permisos = response.data.permisos;
      }, error => {
        this.Err(error);
      });
      this.$http.get("permisos/catalogo").then(response => {
        this.list_cat_permisos = response.data.catpermisos;
      }, error => {
        this.Err(error);
      });
    }
  };

</script>
<style>
  .ancho {
    width: 100px !important;
    text-align: center;
  }

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Forms/Permisos.vue